import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

/* Services */
import {
  AccountsService,
  DataService,
  UsersService,
  TenantService,
  RolesService,
  PermissionsService,
  FileService,
  LookupsService,
  BuildingService,
  VenueService,
  RequestAccessCardService,
  EventService,
  RequestService,
  RequestVenueService,
  AccessCardService,
  RequestAccessCardCancellationService,
  FMService,
  InvoiceService,  AnnouncementService,
  DashboardService,
  SupplierService
} from './data';

import { LoadingIndicatorService, NavigationService } from './services';

/* Guards */
import { AuthGuard } from './guards/auth.guard';

/* Interceptors */
import { AuthenticationInterceptor } from './interceptors/authentication.interceptor';
import { LoadingIndicatorInterceptor } from './interceptors/loading-indicator.interceptor';


@NgModule({
  imports: [
    CommonModule,
    HttpClientModule
  ],
  declarations: [],
  providers: [
    /* Services */
    AccountsService,
    DataService,
    UsersService,
    TenantService,
    RolesService,
    NavigationService,
    PermissionsService,
    FileService,
    LookupsService,
    BuildingService,
    VenueService,
    RequestAccessCardService,
    EventService,
    RequestService,
    RequestVenueService,
    AccessCardService,
    RequestAccessCardCancellationService,
    FMService,
    InvoiceService,
    DashboardService,
    AnnouncementService,
    SupplierService,
    /* Guards */
    AuthGuard,

    /* Interceptors */
    LoadingIndicatorService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useFactory: (service: LoadingIndicatorService) => new LoadingIndicatorInterceptor(service),
      multi: true,
      deps: [LoadingIndicatorService]
    }
  ],
  exports: [
    HttpClientModule
  ]
})
export class CoreModule {
  /* make sure CoreModule is imported only by one NgModule the AppModule */
  constructor(
    @Optional() @SkipSelf() parentModule: CoreModule
  ) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import only in AppModule');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts